import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { useRoute } from 'vue-router';

import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from '@ionic/vue';

import ChapterList from '@/components/ChapterList.vue';

import { useData } from '@/composables/data';
import { IChapter } from '@/support/models/chapter.interface';
import { IUnit } from '@/support/models/unit.interface';


export default /*#__PURE__*/_defineComponent({
  __name: 'UnitPage',
  setup(__props) {

const { getUnitData } = useData();

const route = useRoute();
const courseId = Number(route.params.course as string);
const unitId = Number(route.params.unit as string);

const chapters = ref<IChapter[]>([]);
const unit = ref<IUnit>();

const getData = async () => {
  const response: IUnit | undefined = await getUnitData(courseId, unitId);

  unit.value = response;
  chapters.value = unit.value?.chapters ?? [];
};

getData();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonBackButton), {
                    "default-href": `/course/${_unref(courseId)}`
                  }, null, 8, ["default-href"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(unit.value?.name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), {
        class: "ion-padding",
        fullscreen: true
      }, {
        default: _withCtx(() => [
          _createVNode(ChapterList, {
            "unit-id": _unref(unitId),
            "course-id": _unref(courseId),
            chapters: chapters.value
          }, null, 8, ["unit-id", "course-id", "chapters"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})